export default __webpack_public_path__ + "static/media/goodjob.f8b3eb69.png";